<template>
  <div class="location-actions">
    <a
      :href="campsiteLocationURL"
      target="_blank"
      rel="noopener"
      class="account-action"
    >
      <img
        class="icon"
        src="@/assets/images/google-maps-icon.svg"
        width="17"
        height="24"
        alt=""
      />
      <translate>Location</translate></a
    >

    <a
      :href="campsiteDirectionsURL"
      target="_blank"
      rel="noopener"
      class="account-action"
    >
      <img
        class="icon"
        src="@/assets/images/google-maps-icon.svg"
        width="17"
        height="24"
        alt=""
      />
      <translate>Directions from booking address</translate>
    </a>
  </div>

  <p>
    <translate> GPS: </translate>
    <translate :tt="{ lat: latLng.lat }">
      Latitude {lat, puNumber, maximumFractionDigits:5}
    </translate>
    <translate :tt="{ lng: latLng.lng }">
      Longitude {lng, puNumber, maximumFractionDigits:5}
    </translate>
    <copy-button :text-to-copy="`${latLng.lat}, ${latLng.lng}`" />
  </p>

  <div v-if="directions" class="directions-text">
    <img
      src="@/assets/images/exclamation-mark-outline.svg"
      width="20"
      height="20"
    />
    <p class="preserve-linebreaks">
      {{ directions }}
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { getPointFromStringOrDefault } from '~/utility/geo/latLng'
import googleMap from '~/utility/google-map'

@Component
class CampsiteDirections extends Vue {
  @Prop({ required: true })
  name: string

  @Prop({ required: true })
  fullAddress: string

  @Prop({ required: true })
  directions: string

  @Prop({ required: false })
  point: string | null

  @Prop({ required: true })
  userAddress: string

  get campsiteLocationURL() {
    return `https://www.google.com/maps/search/?api=1&query=${this.latLng.lat},${this.latLng.lng}`
  }

  get latLng() {
    return getPointFromStringOrDefault(this.point)
  }

  get campsiteDirectionsURL(): string {
    return googleMap.googleMapLink(
      this.latLng.lat,
      this.latLng.lng,
      this.name,
      this.userAddress,
    )
  }
}

export default toNative(CampsiteDirections)
</script>
<style scoped>
.directions-text {
  background-color: #e1e5ea80;
  border-radius: var(--border-radius);
  padding: 0.4em;
  display: flex;
  align-items: flex-start;
  gap: 0.25em;
  margin: 1em 0 0;
}

.full-address {
  text-wrap-style: balance;
}

.location-actions {
  align-items: start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1em;
  justify-content: space-between;
  margin: 0.75em 0;
}

.location-actions a {
  padding: 0.4em 0.5em;
  flex: 0 1 auto;
}

.location-actions a .icon {
  margin: -0.2em 0 -0.2em -0.2em;
}
</style>
